"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("@/store/ducks/components/selectors");
const components_1 = require("@/store/ducks/components");
const index_view_1 = __importDefault(require("./index.view"));
function ComponentToast() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const hasErrorSavingChanges = (0, react_redux_1.useSelector)(selectors_1.hasErrorSavingChangesSelector);
    const successSavingChanges = (0, react_redux_1.useSelector)(selectors_1.changesSavedSuccessSelector);
    const isToastOpen = (0, react_redux_1.useSelector)(selectors_1.isComponentToastOpenSelector);
    const onClose = react_1.default.useCallback(() => {
        dispatch((0, components_1.closeComponentToast)());
    }, [components_1.closeComponentToast]);
    const getToastAttributes = () => {
        if (hasErrorSavingChanges) {
            return {
                message: "Error saving component",
                severity: "error",
            };
        }
        if (successSavingChanges) {
            return {
                message: "Component saved successfully",
                severity: "success",
            };
        }
        return { message: "", severity: "info" };
    };
    const toastAttributes = getToastAttributes();
    return (react_1.default.createElement(index_view_1.default, { isOpen: isToastOpen, onClose: onClose, severity: toastAttributes?.severity, message: toastAttributes?.message }));
}
exports.default = ComponentToast;
